import { render, staticRenderFns } from "./PreRegistryList.vue?vue&type=template&id=f3c5e0b2&"
import script from "./PreRegistryList.vue?vue&type=script&lang=js&"
export * from "./PreRegistryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports